import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useQuery } from "react-query";
import { useForm } from "react-hook-form";
//primereact
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Skeleton } from "primereact/skeleton";
import { DataTable } from "primereact/datatable";
import { BreadCrumb } from "primereact/breadcrumb";
import { confirmDialog } from "primereact/confirmdialog";
//components
import Input from "../../../components/input/Input";
import Panel from "../../../components/panel/panel";
import ExportTable from "../../../components/button/ExportButton";
import ModalEditRegistrationType from "./ModalEditRegistrationType";
//services
import { getRegistrationType } from "../../../services/GlobalRoles/getRegistrationTypes";
import { onSubmitType } from "../../../services/Settings/RegistrationType/createRegistrationType";
import { onSubmitDeleteRegistrationType } from "../../../services/Settings/RegistrationType/deleteTypeCli";
import usePermission from "../../../hooks/usePermission";
import { useAppContext } from "../../../context/AppContext";

const CreateRegistrationType = () => {
  usePermission("136"); // Visualizar Tipo de Cadastro
  const { permissions } = useAppContext();
  const items = [
    {
      template: () => (
        <Link
          to={`/settings/createRegistrationType`}
          className="p-breadcrumb-link"
        >
          Tipo de Cadastro
        </Link>
      ),
    },
  ];
  const home = {
    template: () => (
      <Link to={"#"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };

  const onGlobalFilterChange = (e) => {
    setGlobalFilterValue(e.target.value);
  };

  const handleCloseEditModal = () => {
    setVisibleEditModal(false);
  };

  function SubmitEditType(rowData) {
    setSendRowData(rowData);
    setVisibleEditModal(true);
  }
  function SubmitDeleteType(rowData) {
    setSendRowData(rowData);
    confirmDeleteType(rowData);
  }

  const {
    control: controlType,
    handleSubmit: handleSubmitTypes,
    reset: resetType,
    formState: { errors },
  } = useForm();

  const columns = [{ field: "description", header: "Descrição" }];

  const exportColumns = [
    { dataKey: "id", title: "ID" },
    { dataKey: "description", title: "Descrição" },
  ];

  const [visible, setVisible] = useState(false);
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [headerEditModal, setHeaderEditModal] = useState("Alterar");
  const [loading, setLoading] = useState(false); // Inicialmente, vazio
  const [sendRowData, setSendRowData] = useState([]);
  const [visibleEditModal, setVisibleEditModal] = useState(false);
  const [tableToExport, setTableToExport] = useState(null);

  function sendSubmitType(data) {
    let obj = {
      name: data.name,
    };
    console.log(data);
    setVisible(false);
    onSubmitType(resetType, setLoading, setVisible, obj)
      .then(() => {
        // Após a conclusão bem-sucedida de onSubmitCurrentAccount,
        // chame a função refresh
        resetType([]);
        refetch();
      })
      .catch((error) => {
        // Trate erros, se necessário
        console.error("Erro ao enviar a conta corrente:", error);
      });
  }
  const confirmDeleteType = (selectedOptionDelete) => {
    var idType = selectedOptionDelete.id;
    confirmDialog({
      message: "Deseja fazer a exclusão?",
      header: "Confirmação",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Sim",
      rejectLabel: "Não",
      accept: (event) => deleteType(event, idType),
    });
  };
  const deleteType = async (event, idType) => {
    onSubmitDeleteRegistrationType(resetType, setLoading, setVisible, idType)
      .then(() => {
        resetType([]);
        refetch();
      })
      .catch((error) => {
        // Tratar errors
        console.error("Erro ao enviar a conta corrente:", error);
      });
  };

  const {
    data: types,
    refetch,
    isLoading,
  } = useQuery({
    queryKey: ["types"],
    queryFn: () => getRegistrationType(),
    enabled: !!permissions?.includes("136"),
  });

  useEffect(() => {
    if (types) {
      console.log(types);
      const dataWithoutIds = types.map((t) => ({
        ID: t.id,
        Descricao: t.description,
      }));
      // console.log("sem ids", dataWithoutIds);
      setTableToExport(dataWithoutIds);
    }
  }, [types]);

  return (
    <>
      <div className="col-xl-4">
        <BreadCrumb
          model={items}
          home={home}
          style={{
            background: "transparent",
            border: "none",
            fontSize: "16px",
          }}
        />
      </div>
      {permissions &&
        permissions.includes("137") && ( //Adicionar Tipo de Cadastro
          <Panel mainCss="mb-4" title="Criar Tipo de Cadastro">
            <form onSubmit={handleSubmitTypes(sendSubmitType)}>
              <div className="row">
                <div className="col-xl-10 mb-4 form-group">
                  <Input
                    className="w-100"
                    control={controlType}
                    errors={errors}
                    name="name"
                    label="Tipo de Cadastro"
                  />
                </div>
                <div
                  className={`${
                    window.innerWidth <= 992 ? "col-md-12" : "col-xl-1"
                  } m-auto form-group`}
                >
                  <div className="text-center">
                    <Button
                      icon="fa fa-plus"
                      aria-label="Search"
                      className={`rounded-3 py-2.5 w-100`}
                      loading={isLoading}
                    />
                  </div>
                </div>
              </div>
            </form>
          </Panel>
        )}
      <Panel title="Tipos Cadastrados">
        {!types ? (
          <Skeleton variant="rect" width="100%" height={300} />
        ) : (
          <>
            <div>
              <hr className="my-4" />
              <ExportTable
                tableData={tableToExport}
                tabelaKey="Tipos de Registro"
                exportColumns={exportColumns}
                onGlobalFilterChange={onGlobalFilterChange}
                globalFilterValue={globalFilterValue}
              />
              <DataTable
                stripedRows
                showGridlines
                sortMode="multiple"
                selectionMode="single"
                value={types}
                paginator
                // loading={isLoading}
                rows={5}
                sortableColumns={false}
                rowsPerPageOptions={[5, 25, 50]}
                emptyMessage="Nenhuma Informação foi encontrada."
                tableStyle={{
                  minWidth: "1rem",
                  fontSize: "0.8rem",
                  border: "0.8rem",
                }}
              >
                {columns.map((col) => (
                  <Column
                    sortable
                    key={col.field}
                    field={col.field}
                    header={col.header}
                  />
                ))}
                {permissions &&
                  permissions.includes("138") && ( //Editar Tipo de Cadastro
                    <Column
                      header="Ver/Alterar"
                      body={(rowData) => (
                        <div className="text-center">
                          {rowData.id > 9 ? (
                            <button
                              className="btn btn-success btn-btn-sm"
                              onClick={() => SubmitEditType(rowData)}
                            >
                              <i className="fa-solid fa-pen-to-square"></i>
                            </button>
                          ) : (
                            <button
                              className="btn btn-success btn-btn-sm p-disabled"
                              onClick={() => SubmitEditType(rowData)}
                            >
                              <i className="fa-solid fa-pen-to-square"></i>
                            </button>
                          )}
                        </div>
                      )}
                    />
                  )}
                {permissions &&
                  permissions.includes("139") && ( //Excluir Tipo de Cadastro
                    <Column
                      header="Remover"
                      body={(rowData) => (
                        <div className="text-center relative">
                          {rowData.id > 9 ? (
                            <button
                              className="btn btn-danger btn-btn-sm"
                              onClick={() => SubmitDeleteType(rowData)}
                            >
                              <i className="fa-solid fa-trash-can"></i>
                            </button>
                          ) : (
                            <button
                              className="btn btn-danger btn-btn-sm p-disabled"
                              onClick={() => SubmitDeleteType(rowData)}
                            >
                              <i className="fa-solid fa-trash-can"></i>
                            </button>
                          )}
                        </div>
                      )}
                    />
                  )}
              </DataTable>
            </div>
          </>
        )}
      </Panel>

      <ModalEditRegistrationType
        visible={visibleEditModal}
        headerModal={headerEditModal}
        handleCloseModal={handleCloseEditModal}
        setVisible={setVisibleEditModal}
        rowData={sendRowData}
        refresh={refetch}
        loadingAccount={setLoading}
      />
    </>
  );
};

export default CreateRegistrationType;
